
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/9-off-the-beaten-track-places-to-visit-in-japan",
      function () {
        return require("private-next-pages/blog/9-off-the-beaten-track-places-to-visit-in-japan.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/9-off-the-beaten-track-places-to-visit-in-japan"])
      });
    }
  